export default [
    {
        path: '/agent-settings',
        name: 'agent-settings',
        component: () => import ('./views/AgentSettingIndex.vue'),
        meta: {
            title: 'Configurações do Agente',
            icon: 'mdi-google-assistant',
        }
    },
]
